// extracted by mini-css-extract-plugin
export default {"profile-bg":"profileCoverPhoto_profile-bg__wauVm"};